<!--
 * @Author: mazhigang
 * @Date: 2023-09-16 19:32:21
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-11-01 19:19:20
-->
<template>
  <div>
    <div class="bg" v-if="type == '' && useType == 1">
      <div class="logo1">
        <img
          src="https://down.baoanlailou.com/00/askriLogo.png"
          alt=""
          style="width: 120px;height: 120px;"
        />
      </div>
      <div class="btnBox1">
        <div class="btnNew" @click="openUrl2()">
          <img src="https://down.baoanlailou.com/00/IOSDown.png" alt="" />
        </div>
        <div class="btnNew" @click="openUrl3()" style="margin-top: 20px;">
          <img src="https://down.baoanlailou.com/00/AndroidDown.png" alt="" />
        </div>
      </div>
    </div>
    <div class="bg3" v-if="type == '' && useType == 0">
      <div class="logo1">
        <img src="https://down.baoanlailou.com/00/logo.png" alt="" />
      </div>
      <div class="btnBox1">
        <div class="btnNew" @click="openUrl2()">
          <img src="https://down.baoanlailou.com/00/IOSDown.png" alt="" />
        </div>
        <div class="btnNew" @click="openUrl3()" style="margin-top: 20px;">
          <img src="https://down.baoanlailou.com/00/AndroidDown.png" alt="" />
        </div>
      </div>
    </div>
    <div class="bg1" v-if="type == 1">
      <div class="logo">
        <img
          src="https://down.baoanlailou.com/00/logo.png"
          alt=""
          v-if="useType == 1"
        />
        <img
          src="https://down.baoanlailou.com/00/askriLogo.png"
          alt=""
          v-if="useType == 0"
        />
      </div>
      <div class="btnBox1">
        <div class="btnNew" @click="openUrl()">
          <img src="https://down.baoanlailou.com/00/IOSDown.png" alt="" />
        </div>
        <div class="btnNew" @click="openUrl1()" style="margin-top: 20px;">
          <img src="https://down.baoanlailou.com/00/AndroidDown.png" alt="" />
        </div>
      </div>
    </div>
    <div class="bg2" v-if="type == 2">
      <div class="logo">
        <img
          src="https://down.baoanlailou.com/00/askriLogo.png"
          alt=""
          v-if="useType == 1"
        />
        <img
          src="https://down.baoanlailou.com/00/logo.png"
          alt=""
          v-if="useType == 0"
        />
      </div>
      <div class="btnBox1">
        <div class="btnNew" @click="openUrl()">
          <img src="https://down.baoanlailou.com/00/IOSDown.png" alt="" />
        </div>
        <div class="btnNew" @click="openUrl1()" style="margin-top: 20px;">
          <img src="https://down.baoanlailou.com/00/AndroidDown.png" alt="" />
        </div>
      </div>
    </div>
    <div v-if="model1 == true" class="model" @click="close">
      <div style="color: #fff;text-align: right;margin-right: 50px;">
        <div>
          <img
            src="https://down.baoanlailou.com/00/load.png"
            alt=""
            style="width: 77px;height: 60px;"
          />
        </div>
        <div
          style="display: flex;width: 100%;justify-content: end;padding-right: 35px;box-sizing: border-box;"
        >
          <div style="width: 200px;margin-right: 10px;font-size: 20px;">
            请点击右上角，使用默认浏览器打开App下载
          </div>
          <div>
            <img
              src="https://down.baoanlailou.com/00/serf1.png"
              alt=""
              style="width: 74px;height: 96px;"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="messageBox" v-if="model == true">
      下载链接已经为您复制，
      <div>请通过打开系统浏览器进行粘贴下载</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      urlData: {},
      useType: 1, //0 用户端    1保安端
      model: false,
      model1: false,
      type: "", // 空 咖德内部  1保安人员   2保安企业
      key: ""
    };
  },
  mounted() {
    if (this.$route.query.useType) {
      this.useType = this.$route.query.useType;
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.getCode();
    this.getList();
    setTimeout(() => {
      this.postData();
    }, 500);
  },
  methods: {
    postData() {
      console.log(this.key);
      this.$axios
        .post(`/mapi/api/statistice/h5-downPage-statis`, {
          sourceFrom: this.type == "" ? 1 : 2,
          equipmentKey: this.key,
          terminalType: this.useType == 0 ? 1 : 2
        })
        .then(({ data }) => {
          console.log(data);
        })
        .catch()
        .finally();
    },
    async getCode() {
      try {
        const fp = await window.FingerprintJS.load();
        const result = await fp.get();
        this.key = result.visitorId;
      } catch (error) {
        // console.error("生成设备指纹失败:", error);
      }
    },
    isWeChatBrowser() {
      return /MicroMessenger/i.test(navigator.userAgent);
    },
    close() {
      this.model1 = false;
    },
    getList() {
      this.$axios
        .post(`/mapi/api/common/invite/getAppDownloadUrl`, {
          useType: this.useType
        })
        .then(({ data }) => {
          this.urlData = data;
        })
        .catch()
        .finally();
    },
    openUrl() {
      if (this.urlData.iosUrl == "") {
        this.$message("正在建设中");
      } else {
        if (this.type == "") {
          window.location.href = this.urlData.iosUrl;
        } else {
          navigator.clipboard.writeText(this.urlData.iosUrl);
          this.model = true;
          setTimeout(() => {
            this.model = false;
          }, 3000);
        }
      }
    },
    openUrl2() {
      if (this.urlData.iosUrl == "") {
        this.$message("正在建设中");
      } else {
        if (this.isWeChatBrowser()) {
          this.model1 = true;
        } else {
          window.location.href = this.urlData.iosUrl;
        }
      }
    },
    openUrl3() {
      if (this.urlData.androidUrl == "") {
        this.$message("正在建设中");
      } else {
        if (this.isWeChatBrowser()) {
          this.model1 = true;
        } else {
          window.location.href = this.urlData.androidUrl;
        }
      }
    },
    openUrl1() {
      if (this.urlData.androidUrl == "") {
        this.$message("正在建设中");
      } else {
        if (this.type == "") {
          window.location.href = this.urlData.androidUrl;
        } else {
          navigator.clipboard.writeText(this.urlData.androidUrl);
          this.model = true;
          setTimeout(() => {
            this.model = false;
          }, 3000);
        }
        // 使用示例
        // if (this.isWeChatBrowser()) {
        //   console.log("当前浏览器是微信内置浏览器");
        //   // 在这里可以添加针对微信浏览器的特定逻辑
        //   this.model = true;
        // } else {
        //   console.log("当前浏览器不是微信内置浏览器");
        //   window.location.href = this.urlData.androidUrl;
        // }
      }
    }
  }
};
</script>
<style scoped>
.messageBox {
  width: 80%;
  height: 150px;
  background: rgba(0, 0, 0, 0.68);
  border-radius: 22px;
  position: fixed;
  top: 35vh;
  left: 10%;
  text-align: center;
  padding: 50px 20px;
  box-sizing: border-box;
  color: #fff;
  font-size: 16px;
}
.model {
  width: 100%;
  height: 100%;
  background: rgb(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
}
.bg {
  width: 100%;
  height: 100vh;
  background-image: url("https://down.baoanlailou.com/00/askariNew.png");
  background-size: 100% 100%;
  padding: 0 34px;
  box-sizing: border-box;
  overflow: hidden;
}
.bg3 {
  width: 100%;
  height: 100vh;
  background-image: url("https://down.baoanlailou.com/00/user1.png");
  background-size: 100% 100%;
  padding: 0 34px;
  box-sizing: border-box;
  overflow: hidden;
}
.btnBox {
  /* margin-top: 580px; */
  text-align: center;
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  padding: 0 0 30px 0;
  box-sizing: border-box;
}
.btn {
  width: 309px;
  background: linear-gradient(180deg, #31afff 0%, #1677ff 100%);
  border-radius: 10px;
  border: 1px solid #979797;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  line-height: 25px;
  padding: 10px 22px;
  box-sizing: border-box;
  margin: 30px auto 0;
}
.btn1 {
  width: 309px;
  background: linear-gradient(179deg, #00deb0 0%, #04b578 100%);
  border-radius: 10px;
  border: 1px solid #979797;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  line-height: 25px;
  padding: 10px 22px;
  box-sizing: border-box;
  margin: 30px auto 0;
}
.bg1 {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  padding: 0 34px;
  box-sizing: border-box;
  overflow: hidden;
  background-image: url("https://down.baoanlailou.com/00/personBg.png");
}
.bg2 {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  padding: 0 34px;
  box-sizing: border-box;
  overflow: hidden;
  background-image: url("https://down.baoanlailou.com/00/companyBg.png");
}
.logo {
  width: 100%;
  text-align: center;
  position: fixed;
  left: 0;
  top: 25vh;
}
.logo img {
  width: 190px;
  height: 190px;
}
.logo1 {
  width: 100%;
  text-align: center;
  position: fixed;
  left: 0;
  top: 47vh;
}
.logo1 img {
  width: 100px;
  height: 100px;
}
.btnNew {
  width: 100%;
  text-align: center;
  margin-top: 220px;
}
.btnNew img {
  width: 240px;
  height: 45px;
}
.btnBox1 {
  text-align: center;
  position: fixed;
  bottom: 9vh;
  left: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/poster/poster.vue